import {useEffect} from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import {postSubmit, isEmpty, scrollToComponent, stringToDate, formatDate, FORMAT_DATE_BACK} from "@ui-seeker/utils"

import { WEBBACK_V2_API} from "@constants";
import {stockAssDetailsSummaryFilters, stockAssDetailsWidgetEvolutionFilters} from "../../@signals";


export default function useStockAssortmentWidgetsEvolutionChartData() {
    const { showToast } = useAppToast()

    const dataEvolution = useSignal({})
    const dataEvolutionKeys = useSignal({})
    const dateRange = useSignal([])
    const isLoadingDataEvolution = useSignal(false)

    useEffect(() => {
        if (!isEmpty(stockAssDetailsWidgetEvolutionFilters.value)) batch(() => {
            isLoadingDataEvolution.value = true
            dataEvolution.value = {}
            showToast.promise(postSubmit(`${WEBBACK_V2_API}/stock-assortment/details/widgets-evolution`, {
                ...stockAssDetailsSummaryFilters.value,
                ...stockAssDetailsWidgetEvolutionFilters.value
            }).then(res => batch(() => {
                dataEvolution.value = res.chart
                dataEvolutionKeys.value = res.chartKeys
                dateRange.value = [stringToDate(stockAssDetailsWidgetEvolutionFilters.value.startDate), stringToDate(stockAssDetailsWidgetEvolutionFilters.value.endDate)]
                isLoadingDataEvolution.value = false
            })).catch(() => showToast.error()
            ).finally(() => scrollToComponent('evolution-status-chart')))
        })

        if (isEmpty(stockAssDetailsWidgetEvolutionFilters.value)) batch(() => {
            dataEvolution.value = {}
            dataEvolutionKeys.value = {}
        })

    }, [JSON.stringify(stockAssDetailsWidgetEvolutionFilters.value)])

    const onChange = (e) => {
        batch(() => {
            dateRange.value = e
            stockAssDetailsWidgetEvolutionFilters.value = {
                ...stockAssDetailsWidgetEvolutionFilters.value,
                startDate: formatDate(e[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(e[1], { format: FORMAT_DATE_BACK }),
            }
        })
    }

    const resetEvolutionData = () => batch(() => {
        dataEvolution.value = {}
        dataEvolutionKeys.value = {}
        stockAssDetailsWidgetEvolutionFilters.value = {}
    })

    return {
        dataEvolution: dataEvolution.value,
        dataEvolutionKeys: dataEvolutionKeys.value,
        isLoadingDataEvolution: isLoadingDataEvolution.value,
        label: stockAssDetailsWidgetEvolutionFilters.value?.label,
        dateRange: dateRange.value,

        onChange,
        resetEvolutionData
    }
}